// extracted by mini-css-extract-plugin
export var wrapper = "B_b";
export var error = "B_bY";
export var checkbox = "B_cq";
export var label = "B_bP";
export var checked = "B_cr";
export var input = "B_cn";